import React from "react";
import './Rodape.css';

export default function Rodape() {
    return(
        <footer className='home-footer'>
        <h3>
          © {new Date().getFullYear()} yOrbit. Todos os direitos reservados.
        </h3>
      </footer>
    )
}